export default "__VITE_ASSET__7BYNZRQx__"